/* =================== HEADER SCROLL ANIMATION (VANILLA JS) =================== */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    const header = document.getElementById("main-header");
    if (!header) return;

    function handleScroll() {
      if (window.scrollY > 40) {
        header.classList.add("scrolled");
      } else {
        header.classList.remove("scrolled");
      }
    }

    // Listener de scroll com boa performance
    window.addEventListener("scroll", handleScroll, { passive: true });
    
    // Roda uma vez no load caso a página já inicie com scroll
    handleScroll();
  });
})();
